import React from "react";

function redirectForLocalTest(toSubdomain, pathname, history) {

	let host = window.location.host;
	let subList = host.split('.');

	let currentSubdomain = host.split('.')[1] && (host.split('.')[1] !== 'com:3000') ? host.split('.')[0] : "";

	if(currentSubdomain === toSubdomain) {
		history.push({ pathname });
	} else {

		if(toSubdomain) {
			if(currentSubdomain) {
				subList.shift()
				window.location.href = `http://${toSubdomain}.local-test-paylixecommerce.com:3000${pathname}`
			} else {
				window.location.href = `http://${toSubdomain}.local-test-paylixecommerce.com:3000${pathname}`
			}
		} else {
			if(currentSubdomain) {
				subList.shift();
				window.location.href = `http://local-test-paylixecommerce.com:3000${pathname}`
			} else {
				window.location.href = `http://local-test-paylixecommerce.com:3000${pathname}`
			}
		}
	}
}

function redirectForStaging(toSubdomain, pathname, history) {

	let host = window.location.host;
	let subList = host.split('.');
	let currentSubdomain = host.split('.')[1] ? host.split('.')[1] === 'io' ? "" : host.split('.')[0] : "";

	if(currentSubdomain === toSubdomain) {
		history.push({ pathname });
	} else {

		if(toSubdomain) {
			if(currentSubdomain) {
				subList.shift()
				window.location.href = `https://${toSubdomain}.paylixecommerce-staging.io${pathname}`
			} else {
				window.location.href = `https://${toSubdomain}.paylixecommerce-staging.io${pathname}`
			}
		} else {
			if(currentSubdomain) {
				subList.shift();
				window.location.href = `https://paylixecommerce-staging.io${pathname}`
			} else {
				window.location.href = `https://paylixecommerce-staging.io${pathname}`
			}
		}

	}
}
function redirectForWallet(toSubdomain, pathname, history) {

	let host = window.location.host;
	let subList = host.split('.');
	let currentSubdomain = host.split('.')[1] ? host.split('.')[1] === 'io' ? "" : host.split('.')[0] : "";

	if(currentSubdomain === toSubdomain) {
		history.push({ pathname });
	} else {

		if(toSubdomain) {
			if(currentSubdomain) {
				subList.shift()
				window.location.href = `https://${toSubdomain}.paylixecommerce-crispy.io${pathname}`
			} else {
				window.location.href = `https://${toSubdomain}.paylixecommerce-crispy.io${pathname}`
			}
		} else {
			if(currentSubdomain) {
				subList.shift();
				window.location.href = `https://paylixecommerce-crispy.io${pathname}`
			} else {
				window.location.href = `https://paylixecommerce-crispy.io${pathname}`
			}
		}

	}
}


function redirectForProd(toSubdomain, pathname, history) {

	let host = window.location.host;
	let subList = host.split('.');
	let currentSubdomain = host.split('.')[1] ? host.split('.')[1] === 'io' ? "" : host.split('.')[0] : "";

	if(currentSubdomain === toSubdomain) {
		history.push({ pathname });
	} else {

		if(toSubdomain) {
			if(currentSubdomain) {
				subList.shift()
				window.location.href = `https://${toSubdomain}.paylix.gg${pathname}`
			} else {
				window.location.href = `https://${toSubdomain}.paylix.gg${pathname}`
			}
		} else {
			if(currentSubdomain) {
				subList.shift();
				window.location.href = `https://paylix.gg${pathname}`
			} else {
				window.location.href = `https://paylix.gg${pathname}`
			}
		}

	}
}

export function redirectToSubLink(toSubdomain, pathname, history, blank) {

	let host = window.location.host;
	let localTestpaylixecommerce = host.includes('local-test-paylixecommerce');
	let isStaging = host.includes('paylixecommerce-staging');
	let isWallet = host.includes('paylixecommerce-crispy');
	let isProd = host.includes('paylix.gg');

	if(localTestpaylixecommerce) {
		redirectForLocalTest(toSubdomain, pathname, history, blank);

		return null;
	} else if (isStaging) {
		redirectForStaging(toSubdomain, pathname, history, blank);

		return null;
	} else if (isProd) {
		redirectForProd(toSubdomain, pathname, history, blank);

		return null;
	} else if (isWallet) {
		redirectForWallet(toSubdomain, pathname, history, blank);

		return null;
	}
}